import { render, staticRenderFns } from "./monthly-historical-sincerity-gold.vue?vue&type=template&id=c5d8169e&scoped=true&"
import script from "./monthly-historical-sincerity-gold.vue?vue&type=script&lang=js&"
export * from "./monthly-historical-sincerity-gold.vue?vue&type=script&lang=js&"
import style0 from "./monthly-historical-sincerity-gold.vue?vue&type=style&index=0&id=c5d8169e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d8169e",
  null
  
)

export default component.exports